import React, { useRef, useState, useEffect } from 'react';
import SideNavBar from './SideNavBar';
import { useTheme } from '../context/ThemeContext';

const Layout = ({ children, title }) => {
	const { isDark, toggleTheme } = useTheme();
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const sidebarRef = useRef();

	useEffect(() => {
		if (!sidebarOpen) return;
		function handleClick(e) {
			if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
				setSidebarOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [sidebarOpen]);

	return (
		<div className={isDark ? 'dark bg-gray-950 min-h-screen' : 'bg-white min-h-screen'}>
			{/* Theme Toggle Button - Responsive positioning */}
			<button
				className={`fixed top-4 right-4 z-50 rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110 ${
					isDark ? 'bg-gray-800 text-yellow-300 hover:bg-gray-700' : 'bg-white text-indigo-800 border hover:bg-gray-50'
				} sm:top-6 sm:right-6`}
				onClick={toggleTheme}
				aria-label="Toggle theme"
			>
				{isDark ? '🌙' : '☀️'}
			</button>

			{/* Mobile Menu Button - Hidden on larger screens */}
			<button
				className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black shadow-lg hover:bg-gray-50 transition-colors"
				onClick={() => setSidebarOpen(true)}
				aria-label="Open sidebar"
			>
				☰
			</button>

			<div className="flex min-h-screen">
				{/* Desktop Sidebar - Hidden on mobile, visible on tablet and up */}
				<div
					className={`w-56 hidden lg:block ${
						isDark
							? 'bg-gradient-to-b from-indigo-950 to-indigo-800'
							: 'bg-gradient-to-b from-indigo-700 to-blue-500'
					} p-3 font-bold shadow-xl`}
					style={{ minHeight: '100vh' }}
				>
					<SideNavBar darkMode={isDark} />
				</div>

				{/* Mobile Sidebar Overlay */}
				{sidebarOpen && <div className="fixed inset-0 z-40 bg-black/40 lg:hidden" />}
				
				{/* Mobile Sidebar - Slide in from left */}
				<div
					ref={sidebarRef}
					className={`fixed top-0 left-0 z-50 w-72 h-full transform transition-transform duration-300 lg:hidden ${
						isDark
							? 'bg-gradient-to-b from-indigo-950 to-indigo-800'
							: 'bg-gradient-to-b from-indigo-700 to-blue-500'
					} ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} shadow-2xl`}
				>
					<div className="p-3">
						<SideNavBar darkMode={isDark} closeMenu={() => setSidebarOpen(false)} />
					</div>
				</div>

				{/* Main Content Area - Responsive padding and margins */}
				<div className="flex-1 w-full transition-all duration-300">
					{/* Responsive content padding */}
					<div className="px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8 xl:px-10">
						{title && (
							<div className="mt-8 sm:mt-10 text-center">
								<h1 className={`text-xl sm:text-2xl lg:text-3xl font-bold ${
									isDark ? 'text-indigo-100' : 'text-indigo-900'
								}`}>
									{title}
								</h1>
							</div>
						)}
						
						{/* Responsive content container */}
						<div className="mt-4 sm:mt-6 lg:mt-8">
							{children}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Layout;


